import React from 'react';
import List, { defaultFilters } from '../cruds/List';
import DepartmentCopyEdit from './DepartmentCopyEdit';
import Table, { Column } from '../components/container/Table';
import { LocalizedOutputValue } from '../components/output/OutputValue';
import { CopyButton } from '../components/output/CrudButton';
import OutputValue from '../components/output/OutputValue';
import MainContainer from '../components/MainContainer';
import { Switch, Route } from 'react-router-dom';

const ENTITY_NAME = 'departments';
const ENTITY_ROUTE = 'departments/copy';
const TITLE = 'departmentsCopy.title';

const CrudEdit = props => (
  <DepartmentCopyEdit
        {...props}
        title={TITLE}
        entityName={ENTITY_NAME}
        entityRoute={ENTITY_ROUTE}
        entityId={props.match.params.number}
  />
);

const CrudList = props => {
  const table = <Table>
                  <Column label="departmentsCopy.name" orderingName="NAME"><OutputValue name="name" /></Column>
                  <Column label="departmentsCopy.area" orderingName="AREA"><OutputValue name="area" /></Column>
                  <Column label="departmentsCopy.companyName"><OutputValue name="companyName" /></Column>
                  <Column label="departmentsCopy.manager" orderingName="MANAGER"><OutputValue name="manager" /></Column>
                  <Column label="departmentsCopy.state.name" orderingName="STATE">
                    <LocalizedOutputValue name="state" prefix="departmentsCopy.state" />
                  </Column>
                  <Column label="departmentsCopy.building" orderingName="BUILDING"><OutputValue name="building" /></Column>
                  <Column label="departmentsCopy.labManager" orderingName="LAB_MANAGER"><OutputValue name="labManager" /></Column>
                  <Column label="departmentsCopy.site" orderingName="SITE"><OutputValue name="site" /></Column>
                  <Column label="departmentsCopy.dvrIt" orderingName="DVRIT"><OutputValue name="dvrIt" /></Column>
                  <Column label="departmentsCopy.notes" orderingName="COMPANY"><OutputValue name="notes" /></Column>
                  <Column>
                    <CopyButton entityRoute={props.match.url} />
                  </Column>
                </Table>;

  return (
    <List title={TITLE}
        entityName={ENTITY_NAME}
        entityRoute={ENTITY_ROUTE}
        component={table}
        filters={defaultFilters()}
        defaultOrdering="NAME"
        hideAddButton={true}
    />
  );
};

const DepartmentsCopy = props => {
  const basePath = props.match.url;
  return (
    <MainContainer>
      <Switch>
        <Route exact path={basePath} component={CrudList} />
        <Route exact path={basePath + '/:number'} render={props => <CrudEdit {...props} />} />
      </Switch>
    </MainContainer>
  );
};

export default DepartmentsCopy;



// WEBPACK FOOTER //
// ./src/main/pages/DepartmentsCopy.js